module.exports = __webpack_public_path__ + "img/p1-logo.d2e52ce6.png";